import { render, staticRenderFns } from "./batchUpdatEditForm.vue?vue&type=template&id=065127c8&"
import script from "./batchUpdatEditForm.vue?vue&type=script&lang=js&"
export * from "./batchUpdatEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports